import React, { setGlobal } from "reactn";

import { BrowserRouter as Router } from "react-router-dom";

// themeProvider
import { ThemeProvider } from "styled-components";

// routes
import Routes from "./_routes/Routes";

// components
import ErrorBoundary from "./_common/error/ErrorBoundary";

// styled components
import AppWrapper from "./App.styled";
import ThemeProviderStyled from "./_theme/ThemeProvider.styled";

const baseName = window.location.href.includes("localhost") ? window.location.pathname : "myAccount";

const anPostAppCheck = () => {
    if (navigator.userAgent.indexOf("An Post") !== -1) {
        return true;
    }
    return false;
};

function App() {
    setGlobal({
        values: {
            ciamUserId: window.ciamUID
        },
        profile: {},
        addressObj: {},
        navData: [],
        sideNavData: [],
        callSideNav: false,
        userProfile: {},
        businessName: "",
        firstName: "",
        lastName: "",
        email: "",
        isBusiness: false,
        isCollapsed: false,
        sideNavIndex: 0,
        activeTab: "",
        businessBanner: false,
        customsBanner: false,
        mobileBanner: false,
        mydelsRegistered: false,
        mobileNav: null,
        topNav: null,
        isAnPostApp: anPostAppCheck()
    });

    return (
        <>
            <ThemeProvider theme={ThemeProviderStyled}>
                <AppWrapper>
                    <ErrorBoundary>
                        <Router basename={`${baseName}`}>
                            <Routes />
                        </Router>
                    </ErrorBoundary>
                </AppWrapper>
            </ThemeProvider>
        </>
    );
}

export default App;
